import api from "src/api/axiosInstance";
import { setPriceRange } from "src/store/slices/priceRange-slice";
import { store } from "src/store/store";

export const fetchPriceRange = async () => {
  try {
    const response = await api.get(`/productpricerange`);
    const result = response.data; // Use response.data instead of response.json()
    
    if (result && typeof result.min_price === 'number' && typeof result.max_price === 'number') {
      store.dispatch(setPriceRange(result));
      return result;
    } else {
      console.error("Invalid price range data format:", result);
      return { min_price: 0, max_price: 20000 };
    }
  } catch (error) {
    console.error("Error fetching price range:", error);
    return { min_price: 0, max_price: 20000 };
  }
};